import { useEffect, useRef, useState } from 'react';
import { useAddon } from '@atlassian/jira-addon-store/src/index.tsx';
import { DEFAULT_LOAD_COUNT_FAV } from '@atlassian/jira-favorites-store/src/constants.tsx';
import { useFavoriteActions } from '@atlassian/jira-favorites-store/src/index.tsx';
import { useForgeGlobalItems } from '@atlassian/jira-forge-global-items-store/src/index.tsx';
import { useForgePersonalSettingsItems } from '@atlassian/jira-forge-personal-settings-items-store/src/index.tsx';
import { useCreateProjectPermissionActions } from '@atlassian/jira-nav-item-service/src/services/create-project-permisson/index.tsx';
import { useRecentActions } from '@atlassian/jira-recents-store/src/index.tsx';
import usePageLoadedSubscriber from '@atlassian/jira-spa-state-controller/src/components/page-loaded-state/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';

export const InitialDataLoader = () => {
	const [, { loadRecentAll }] = useRecentActions();
	const [, { loadFavoriteAll }] = useFavoriteActions();
	const [, { fetchCreateProjectPermission }] = useCreateProjectPermissionActions();
	const [, { load: loadForgeGlobalItem }] = useForgeGlobalItems();
	const [, { load: loadForgePersonalSettingsItem }] = useForgePersonalSettingsItems();
	const [, { load: loadAddons }] = useAddon();

	const hasFetchedAll = useRef(false);
	const [{ hasLoaded }] = usePageLoadedSubscriber();
	const [hasTimedOut, setHasTimedOut] = useState(false);

	const accountId = useAccountId();
	const isAnonymous = useIsAnonymous();
	const cloudId = useCloudId();

	useEffect(() => {
		if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
			loadRecentAll();
			loadFavoriteAll(DEFAULT_LOAD_COUNT_FAV);
			loadForgeGlobalItem({ cloudId, isAnonymous });
			loadForgePersonalSettingsItem({ cloudId, isAnonymous });
			fetchCreateProjectPermission();
			loadAddons();
			hasFetchedAll.current = true;
		}
	}, [
		hasLoaded,
		hasTimedOut,
		hasFetchedAll,
		loadRecentAll,
		loadFavoriteAll,
		fetchCreateProjectPermission,
		loadForgeGlobalItem,
		loadForgePersonalSettingsItem,
		loadAddons,
		accountId,
		cloudId,
		isAnonymous,
	]);

	// given not all pages use SpaStateReady yet, we fallback to timeout
	// so we preload nav items anyway after some time
	useEffect(() => {
		let t: ReturnType<typeof setTimeout>;
		if (!hasLoaded) t = setTimeout(() => setHasTimedOut(true), 10 * 1000);
		return () => clearTimeout(t);
	}, [hasLoaded, setHasTimedOut]);

	return null;
};
